import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ISidebarState {
	logoUrl: string | null;
}

const initialState: ISidebarState = {
	logoUrl: null,
};

const sidebarSlice = createSlice({
	name: "sidebar",
	initialState,
	reducers: {
		updateSidebarLogo(state, action: PayloadAction<string | null>) {
			state.logoUrl = action.payload;
		},
	},
});

export const { updateSidebarLogo } = sidebarSlice.actions;
export default sidebarSlice.reducer;